import { FormControl, Grid, InputLabel, MenuItem, Select } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { configService, queueService, twilioService } from '../services';
import { getConfig, hasLoaded, load as loadConfig } from '../store/slices/configSlice';
import { load as loadBookings } from "../store/slices/bookingSlice";
import { load as loadSalesAreas } from "../store/slices/salesAreaSlice";
import { getAllUsers } from '../store/slices/pipedriveUserSlice';
import { getAllAreas } from "../store/slices/salesAreaSlice";
import {AgGridReact, AgGridColumn} from 'ag-grid-react';
import moment from 'moment';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';


export const CallQueuePath = "/call-queue";

function CallQueue(props) {
    const dispatch = useDispatch();
    const [agentSelect, setAgentSelect] = React.useState('0');
    const [salesAreaSelect, setSalesAreaSelect] = React.useState('0');
    const [workers, setWorkers] = React.useState([]);
    const [calls, setCalls] = React.useState([]);
    const [lastUpdate, setLastUpdate] = React.useState(null);

    const confighasLoaded = useSelector(hasLoaded)
    const config = useSelector(getConfig)
    const pipedriveUsers = useSelector(getAllUsers)
    const salesAreas = useSelector(getAllAreas);

    useEffect(() => {
        if (!confighasLoaded) {
            configService.getConfig().then((config) => {
                if (config.Success) {
                //set the config to store
                dispatch(loadConfig(config.Data.Config));
                //save booking info
                dispatch(loadBookings(config.Data.BookingInfo));
                //process sales areas and put them in store
                let saData = [];
                Object.keys(config.Data.AvailableSalesAreas).map(k => {
                    saData.push({
                    ID: config.Data.AvailableSalesAreas[k],
                    Label: k
                    });
                });
                dispatch(loadSalesAreas(saData));
                }

            })
        }
    }, [confighasLoaded])

    useEffect(() => {
        fetchAllData();
        const mrTimeout = window.setInterval(fetchAllData, 60000)
        return () => window.clearInterval(mrTimeout)
    }, [])

    const fetchAllData = () => {
        twilioService.getAllUsers().then(resp => {
            let nw = [];
            if (!resp) {
                throw "No Workers Found";
            }
            resp.forEach(worker => {
                if (worker.skills && worker.skills.includes("leadgen")) {
                    nw.push(worker.email)
                }
            })
            nw.sort();
            setWorkers(nw)
        }).then(() => {
            //get all the calls from the server
            queueService.getCallQueue().then((resp) => {
                setCalls(resp.Data.Calls)
            }).then(() => {
                setLastUpdate(new Date());
            })
        })
        .catch(err => {
            console.error(err)
        })
    }

    const updateAgentSelect = (e) => {
        setAgentSelect(e.target.value);
    }

    const updateSalesAreaSelect = (e) => {
        setSalesAreaSelect(e.target.value);
    }

    const selectedPipedriveUser = pipedriveUsers[agentSelect] || "0";
    return (
        <>
            <h1 style={{fontFamily: "Ink", textAlign: "center", padding: "20px"}}>
            Call Queue</h1>
            <Grid container spacing={2} style={{padding: "20px"}}>
                <Grid item xs={3}>
                    <FormControl style={{width: "100%"}}>
                        <InputLabel>CC Agent</InputLabel>
                        <Select style={{width: "100%"}} value={agentSelect} onChange={updateAgentSelect}>
                            <MenuItem key='worker-all' value="0">All</MenuItem>
                            {
                                workers.map(w => {
                                    return (
                                        <MenuItem key={`worker-${w}`} value={w}>{w}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={3}>
                    <FormControl style={{width: "100%"}}>
                        <InputLabel>Sales Area</InputLabel>
                        <Select style={{width: "100%"}} value={salesAreaSelect} onChange={updateSalesAreaSelect}>
                            <MenuItem key='sa-all' value="0">All</MenuItem>
                            {
                                salesAreas.map(sa => {
                                    return (
                                        <MenuItem key={`worker-${sa.ID}`} value={sa.ID}>{sa.Label}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
            <Grid xs={12} style={{padding: "20px", height: '100%', overflow: 'scroll'}}>
                {
                    calls.map(allCalls => {
                        let rowData = allCalls.contacts || [];
                        if (selectedPipedriveUser != 0) {
                            rowData = rowData.filter(c => {
                                return c.PipedriveUserID === selectedPipedriveUser;
                            })
                        }
                        if (salesAreaSelect !== '0') {
                            rowData =rowData.filter(c => {
                                return c.PipedriveSalesArea == parseInt(salesAreaSelect);
                            })
                        }
                        return (
                            <>
                                <h2 style={{fontFamily: "Ink", textAlign: "center", padding: "20px"}}>
                                {allCalls.Name} ({rowData.length})</h2>
                                {
                                    rowData.length > 0 && <CallTable data={rowData} salesAreas={salesAreas} pipedriveUsers={pipedriveUsers} />
                                }
                                {
                                    rowData.length == 0 && <div style={{textAlign: 'center'}}>NO CALLS</div>
                                }
                            </>
                        )
                    })
                }
            </Grid>
        </>
    )
}

export default CallQueue;

function CallTable(props) {
    const now = moment();

    return (
        <table style={{width: "100%"}}>
            <thead>
                <tr>
                    <th>Call Time</th>
                    <th>Deal ID</th>
                    <th>Phone Number</th>
                    <th>Sales Area</th>
                    <th>Rebirth</th>
                    <th>User</th>
                </tr>
            </thead>
            <tbody>
                {
                    props.data.map(d => {
                        const t = moment(d.CallTime);
                        const sa = props.salesAreas.find(s => {
                            return s.ID === d.PipedriveSalesArea
                        })
                        let email = '';
                        Object.keys(props.pipedriveUsers).some((ix) => {
                            if (props.pipedriveUsers[ix] === d.PipedriveUserID) {
                                email = ix
                                return true
                            }
                            return false
                        })
                        return(
                            <tr style={{textAlign: 'center', backgroundColor: now.isAfter(t) ? 'rgba(0, 255, 0, 0.1)' : '#ececec'}}>
                                <td>{t.format('YYYY-MM-DD HH:mm')}</td>
                                <td>{d.PipedriveDealID}</td>
                                <td>{d.PhoneNumber}</td>
                                <td>{sa && sa.Label || 'Unknown'}</td>
                                <td>{d.PipedriveRebirthCount}</td>
                                <td>{email || 'unknown'}</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </table>
    )
}
